export const statusOptions =  [
    {
      id: "",
      name_es: "Estado actual",
      label: "Current status",
      label_es: "Estado actual",
      label_en: "Current status",
      checked: false
    },
    {
      id: "submitted",
      name_es: "Postulado",
      label: "Submitted",
      label_es: "Postulado",
      label_en: "Submitted",
      checked: false
    },
    {
      id: "awarded",
      name_es: "Adjudicado",
      label: "Awarded",
      label_es: "Adjudicado",
      label_en: "Awarded",
      checked: false
    },
    {
      id: "ongoing",
      name_es: "Vigente",
      label: "Ongoing",
      label_es: "Vigente",
      label_en: "Ongoing",
      checked: true
    },
    {
      id: "finalized",
      name_es: "Finalizado",
      label: "Finalized",
      label_es: "Finalizado",
      label_en: "Finalized",
      checked: false
    },
    {
      id: "cancelled",
      name_es: "Cancelado",
      label: "Cancelled",
      label_es: "Cancelado",
      label_en: "Cancelled",
      checked: false
    },
    {
      id: "unsuccessful",
      name_es: "Infructuoso",
      label: "Unsuccessful",
      label_es: "Infructuoso",
      label_en: "Unsuccessful",
      checked: false
    }
];

export const statusOptionsAllChecked =  [
  {
    id: "",
    name_es: "Estado actual",
    label: "Current status",
    label_es: "Estado actual",
    label_en: "Current status",
    checked: true
  },
  {
    id: "submitted",
    name_es: "Postulado",
    label: "Submitted",
    label_es: "Postulado",
    label_en: "Submitted",
    checked: true
  },
  {
    id: "awarded",
    name_es: "Adjudicado",
    label: "Awarded",
    label_es: "Adjudicado",
    label_en: "Awarded",
    checked: true
  },
  {
    id: "ongoing",
    name_es: "Vigente",
    label: "Ongoing",
    label_es: "Vigente",
    label_en: "Ongoing",
    checked: true
  },
  {
    id: "finalized",
    name_es: "Finalizado",
    label: "Finalized",
    label_es: "Finalizado",
    label_en: "Finalized",
    checked: true
  },
  {
    id: "cancelled",
    name_es: "Cancelado",
    label: "Cancelled",
    label_es: "Cancelado",
    label_en: "Cancelled",
    checked: true
  },
  {
    id: "unsuccessful",
    name_es: "Infructuoso",
    label: "Unsuccessful",
    label_es: "Infructuoso",
    label_en: "Unsuccessful",
    checked: true
  }
];